import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getVisitorId = () =>
  cookies.get<string>('JobseekerVisitorId') || '';

export const useVisitorId = () => getVisitorId();

export const getSolId = () => cookies.get<string>('sol_id') || '';

export const useSolId = () => getSolId();
